import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform, ModalController } from 'ionic-angular';

import { ConsumerPunchCardHandler } from '../../providers/consumer-punch-card-handler';
import { ConsumerPunchCardManagerPage } from '../consumer-punch-card-manager/consumer-punch-card-manager';

import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';
import { ConsumerBusinessMainHandlerProvider } from '../../providers/consumer-business-main-handler';

import { Globals } from '../../providers/globals';

import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';

declare var google: any;

/**
 * Generated class for the ConsumerBusinessPunchCardListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-consumer-business-punch-card-list',
  templateUrl: 'consumer-business-punch-card-list.html',
})
export class ConsumerBusinessPunchCardListPage {

  	business: any = {
		Id: 0,
		ImagePath: ""
	};

	businessId: any;
	filePath: any;
	businessFilePath: any;

	isPinned: any = false;

	hasBonds: any = true;
	hasPunchCards: any = true;
	hasOffers: any = true;

	bonds: any = [];
	punchCards: any = [];
	offers: any = [];

	businessItems: any = "bonds";

	requiresReload: boolean = false;
	isLoading: boolean = false;
	isRefreshing: boolean = false;

	map: any;

	constructor(
		public modalCtrl: ModalController,
		public navCtrl: NavController,
		public navParams: NavParams,
		public punchCardHandler: ConsumerPunchCardHandler,
		public consumerBusinessMainHandlerProvider: ConsumerBusinessMainHandlerProvider, 
		public consumerBusinessHandlerProvider: ConsumerBusinessHandlerProvider,
		public pushNotificationHandlerProvider: PushNotificationHandlerProvider,
		private elRef: ElementRef,
		public globals: Globals,
		public platform: Platform,
		private launchNavigator: LaunchNavigator
	) {
		this.filePath = this.globals.fileUrl;
		this.business = this.consumerBusinessMainHandlerProvider.business;	
		this.businessFilePath = this.globals.fileUrl + this.business.ImagePath;

		this.fetchBusiness(null);
	}

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.fetchBusiness(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	ionViewDidLoad() {
		if(!this.requiresReload){
			this.loadBusinessInfo();
		}
	}	

	loadBusinessInfo(){

		this.businessFilePath = this.globals.fileUrl + this.business.ImagePath;

		this.loadPunchCards(null);
	}

	fetchBusiness(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.consumerBusinessHandlerProvider.getBusinessByIdAndUser(
		{
			id: (this.business.Id == 0) ? this.businessId : this.business.Id,
			cb: (business)=>{
				this.business = business;		

				this.loadBusinessInfo()

				if(typeof cb == "function")
					cb()	

				this.isLoading = false;
			}
		})
	}

	loadPunchCards(cb){
		this.punchCardHandler.getPunchCardsByBusinessId({
			businessId: this.business.Id,
			page: 1,
			size: 20,
			cb:(punchCards)=>{
				if(punchCards.length == 0){
					this.hasPunchCards = false;
				}else{
					this.hasPunchCards = true;
				}

				console.log("hasPunchCards: " + this.hasPunchCards);
				console.log("punchCards.length: " + punchCards.length);

				this.punchCards = punchCards;

				for (var i = this.punchCards.length - 1; i >= 0; i--) {
					this.punchCards[i].summary = 
						this.punchCards[i].TotalUserPunches + 
						" punches of " + 
						this.punchCards[i].PunchQuantity + " done!";			
				}

				if(typeof cb == "function")
					cb()			
			}
		})
	}	

	managePunchCard($e, punchCard){
	    // this.navCtrl.push(ConsumerPunchCardManagerPage, {
	    //   punchCard: punchCard
	    // });			

      	let profileModal = this.modalCtrl.create(ConsumerPunchCardManagerPage, {
			punchCard: punchCard
		});
		
		profileModal.present();  
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-business-punch-card-list/consumer-business-punch-card-list.ts